import React from "react";
import Checkbox from "./checkbox";

const customNumberCheckboxProps = {
    label: "Произвольный ввод",
    inputProps: { name: "useCustomNumber" },
    bWrapper: "mt-2 d-flex align-items-center",
    fieldWrapper: "col-auto p-0",
    labelWrapper: "ml-2 mb-0 small text-muted",
    checkboxWrapCname: "my-0",
    fieldBeforeLabel: true,
};

const withoutPlaceholder = (inputProps) => {
    const nextInputProps = { ...inputProps };
    delete nextInputProps.placeholder;
    return nextInputProps;
};

export const getCustomNumberConfig = ({ number, useCustomNumber, numberValidator }) => ({
    ...number,
    inputProps: useCustomNumber ? withoutPlaceholder(number.inputProps) : number.inputProps,
    type: useCustomNumber ? undefined : number.type,
    validators: number.validators.filter((validator) => (useCustomNumber ? validator !== numberValidator : true)),
});

export default function CustomNumberField({
    number,
    numberValidator,
    onCustomNumberChange,
    renderField,
    useCustomNumber,
}) {
    return renderField({
        ...getCustomNumberConfig({ number, useCustomNumber, numberValidator }),
        inputBottomText: onCustomNumberChange ? (
            <Checkbox {...customNumberCheckboxProps} onChange={onCustomNumberChange} value={useCustomNumber} />
        ) : null,
    });
}
